(() => {
  const config = window.LANDER_CONFIG || JSON.parse(document.getElementById('lander-config').textContent);
  window.LANDER_CONFIG = config;
  const date = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Athens', year: 'numeric', month: 'long', day: 'numeric'
  }).format(new Date());
  document.querySelector('#publication-date').textContent = date;
  for (const element of document.querySelectorAll('[data-image]')) {
    const asset = config.images[element.dataset.image];
    if (!asset?.src) continue;
    const originalContent = [...element.childNodes];
    const img = element.querySelector('img') || document.createElement('img');
    const hero = element.dataset.image.startsWith('hero-');
    // Set scheduling and intrinsic size before assigning src or attaching new images.
    const early = config.imageLoadingMode === 'early';
    img.loading = hero || early ? 'eager' : (asset.loading || 'lazy');
    img.fetchPriority = hero ? 'high' : (early ? 'low' : 'auto');
    img.decoding = 'auto';
    img.alt = asset.alt || '';
    img.width = asset.width;
    img.height = asset.height;
    if (asset.objectPosition) img.style.objectPosition = asset.objectPosition;
    if (asset.zoom) {
      img.style.transform = 'scale(' + asset.zoom + ')';
      img.style.transformOrigin = asset.objectPosition || '50% 50%';
    }
    const loaded = () => {
      element.classList.add('has-image');
      element.classList.remove('avatar-placeholder');
      element.removeAttribute('role');
      element.removeAttribute('aria-label');
    };
    img.addEventListener('load', loaded, { once: true });
    img.addEventListener('error', () => {
      element.title = 'Image could not be loaded: ' + asset.src;
      if (!originalContent.includes(img)) element.replaceChildren(...originalContent);
    }, { once: true });
    if (asset.sizes && img.getAttribute('sizes') !== asset.sizes) img.sizes = asset.sizes;
    if (asset.srcSet && img.getAttribute('srcset') !== asset.srcSet) img.srcset = asset.srcSet;
    if (img.getAttribute('src') !== asset.src) img.src = asset.src;
    if (!element.contains(img)) element.replaceChildren(img);
    if (img.complete && img.naturalWidth) loaded();
  }
  for (const badge of document.querySelectorAll('[data-author-check]')) {
    badge.hidden = config.showAuthorCheck !== true;
  }
  for (const link of document.querySelectorAll('[data-store-link]')) {
    link.href = config.ctaUrl;
  }
  for (const button of document.querySelectorAll('[data-cta]')) {
    button.firstChild.textContent = (config.ctaLabel || 'Check Official GynoLabs Availability') + ' ';
    if (config.ctaUrl) {
      button.href = config.ctaUrl;
      button.removeAttribute('aria-disabled');
      button.removeAttribute('tabindex');
      button.closest('.cta-wrap').querySelector('.cta-status').hidden = true;
    } else {
      button.addEventListener('click', event => {
        event.preventDefault();
        const status = button.closest('.cta-wrap').querySelector('.cta-status');
        status.textContent = 'Destination URL missing — set ctaUrl in config.js';
        status.setAttribute('role', 'status');
      });
      button.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          button.click();
        }
      });
    }
  }
})();
